var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPickupoff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2439_25566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 13.8517V6.14853C17.9994 6.03727 17.9695 5.92812 17.9132 5.83211C17.857 5.73609 17.7764 5.65661 17.6797 5.60166L10.8047 1.73447C10.7121 1.68099 10.607 1.65283 10.5 1.65283C10.393 1.65283 10.2879 1.68099 10.1953 1.73447L3.32031 5.60166C3.22356 5.65661 3.143 5.73609 3.08676 5.83211C3.03052 5.92812 3.0006 6.03727 3 6.14853V13.8517C3.0006 13.9629 3.03052 14.0721 3.08676 14.1681C3.143 14.2641 3.22356 14.3436 3.32031 14.3985L10.1953 18.2657C10.2879 18.3192 10.393 18.3474 10.5 18.3474C10.607 18.3474 10.7121 18.3192 10.8047 18.2657L17.6797 14.3985C17.7764 14.3436 17.857 14.2641 17.9132 14.1681C17.9695 14.0721 17.9994 13.9629 18 13.8517Z",
    stroke: "#2A2D2F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3281 11.9141V7.85156L6.75 3.67188",
    stroke: "#2A2D2F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9141 5.82812L10.5703 10L3.08594 5.82812",
    stroke: "#2A2D2F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5703 10L10.5 18.3438",
    stroke: "#2A2D2F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2439_25566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupoff);
export default __webpack_public_path__ + "static/media/pickupoff.dc3d5d33571ced19e3394217ca1f1486.svg";
export { ForwardRef as ReactComponent };